import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  dropdown: {
    marginBottom: 8,
    maxWidth: 354,
  },
  chip: {
    marginBottom: 8,
    marginRight: 8,
  },
  secondarySaveButton: {
    [theme.breakpoints.up('sm')]: {
      marginRight: 16,
    },
  },
  emphasizedText: {
    fontWeight: 600,
    fontSize: '1em',
    lineHeight: '1.5em',
  },
  dangerText: {
    fontWeight: 600,
    color: theme.palette.error.main,
  },
}));
